import { Component, OnInit } from '@angular/core';
import { DateRangeService } from '../../../services/date-range.service';
import { SectionsViewModel, SectionViewModel } from '../../../models/section';
import { NavigationService } from '../../../services/navigation.service';
import { BaseNavigationComponent } from '../../shared/base-navigation/base-navigation';
import { OrganisationService } from '../../../services/organisation.service';
import { environment } from '../../../../environments/environment';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'sidebar-date-range',
    templateUrl: './date-range.component.html',
    standalone: false,
})
export class DateRangeComponent
    extends BaseNavigationComponent
    implements OnInit
{
    viewModel: SectionsViewModel | undefined;
    isAuthed = false;

    constructor(
        private dateRangeService: DateRangeService,
        navigationService: NavigationService,
        organisationService: OrganisationService,
        private notificationService: NotificationService
    ) {
        super(navigationService, 'DateRangeComponent', organisationService);
    }

    ngOnInit() {
        this.dateRangeService.dateRangeLoaded.subscribe(() => {
            this.viewModel = this.dateRangeService.currentSections;
        });
    }

    apply() {
        this.dateRangeService.dateRangeChanged.next();
        this.close();
        this.notificationService.success('These dates have been applied');
    }

    changeSelection(value: number, section: SectionViewModel) {
        section.options.forEach((opt) => {
            opt.isSelected = opt.value === value;

            if (opt.isSelected) section.selectedOption = value;
        });
    }

    reset() {
        if (!this.viewModel) return;

        this.viewModel.sections.forEach((sect) => {
            sect.options.forEach((opt) => (opt.isSelected = false));

            const lastOption = sect.options[0];
            lastOption.isSelected = true;

            sect.selectedOption = lastOption.value;
        });

        this.dateRangeService.dateRangeChanged.next();
        this.close();
    }

    openNexus() {
        window.open(environment.nexus_url, '_blank');
    }

    closePage() {
        this.navigationService.closeAllTabs();
    }
}
